<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
      <BlockUI v-if="busy">
        <div class="loader"></div>
      </BlockUI>
      <div class="row mb-2">
        <div class="col">
          <h1 class="text-white pt-3 px-3">SHIPPOP POP - ประวัติการอัพเดท</h1>
          <p class="text-white pb-3 px-3">รายละเอียดการอัพเดทแต่ละเวอร์ชัน</p>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8 mb-5">
      <div class="card shadow">
        <div class="row">
          <div class="col-2">
            <a href="#" @click="all_version()" class="text-version"
              >รายการเวอร์ชัน</a
            >
            <div
              v-for="(value, i) in list_version_reverse"
              :key="i"
              class="text-last"
            >
              <a
                href="#"
                @click="version_detail(value.ver)"
                class="link"
                v-if="i == 0"
                >{{ value.ver }} (ล่าสุด)</a
              >
              <a
                href="#"
                @click="version_detail(value.ver)"
                class="link"
                v-else
                >{{ value.ver }}</a
              >
            </div>
          </div>

          <div class="col-9">
            <div class="border-left">
              <div v-for="(value, i) in list_version_reverse" :key="i">
                <div
                  v-if="value.ver == ver_detail && show_detail == true"
                  class="padding-bottom"
                >
                  <div v-for="value2 in value.description" :key="value2">
                    <h2 v-if="i == 0" >
                      มีอะไรใหม่ในเวอร์ชัน {{ value.ver }}
                      <small class="badge badge-red"> ล่าสุด </small>
                    </h2>
                    <h2 v-else >เวอร์ชัน {{ value.ver }}</h2>
                    <h6 class="version-date">{{ value.date }}</h6>

                    <div class="row" v-if="value2.new != '' ">
                      <div class="col-2">
                        <div class="text-right">
                          <small class="badge badge-green">
                            เพิ่มมาใหม่
                          </small>
                        </div>
                      </div>
                      <div class="col-10">
                        <div class="padding-bootom">{{ value2.new }}</div>
                      </div>
                    </div>

                    <div class="row" v-if="value2.update != '' ">
                      <div class="col-2">
                        <div class="text-right">
                          <small class="badge badge-blue"> อัพเดท </small>
                        </div>
                      </div>
                      <div class="col-10">
                        <div class="padding-bootom">{{ value2.update }}</div>
                      </div>
                    </div>

                    <div class="row" v-if="value2.edit != '' ">
                      <div class="col-2">
                        <div class="text-right">
                          <small class="badge badge-orange"> แก้ปัญหา </small>
                        </div>
                      </div>
                      <div class="col-10">
                        <div class="padding-bootom">{{ value2.edit }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else-if="show_detail == false" class="padding-bottom">
                  <div v-for="value2 in value.description" :key="value2">
                    <h2 v-if="i == 0" >
                      มีอะไรใหม่ในเวอร์ชัน {{ value.ver }}
                      <small class="badge badge-red"> ล่าสุด </small>
                    </h2>
                    <h2 v-else >เวอร์ชัน {{ value.ver }}</h2>
                    <h6 class="version-date">{{ value.date }}</h6>

                    <div class="row" v-if="value2.new != '' ">
                      <div class="col-2">
                        <div class="text-right">
                          <small class="badge badge-green">
                            เพิ่มมาใหม่
                          </small>
                        </div>
                      </div>
                      <div class="col-10">
                        <div class="padding-bootom">{{ value2.new }}</div>
                      </div>
                    </div>

                    <div class="row" v-if="value2.update != '' ">
                      <div class="col-2">
                        <div class="text-right">
                          <small class="badge badge-blue"> อัพเดท </small>
                        </div>
                      </div>
                      <div class="col-10">
                        <div class="padding-bootom">{{ value2.update }}</div>
                      </div>
                    </div>

                    <div class="row" v-if="value2.edit != '' ">
                      <div class="col-2">
                        <div class="text-right">
                          <small class="badge badge-orange"> แก้ปัญหา </small>
                        </div>
                      </div>
                      <div class="col-10">
                        <div class="padding-bootom">{{ value2.edit }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _changlog from "@/assets/scss/pages/_changlog.scss";
const API_URL = process.env.VUE_APP_API;
export default {
  name: "dashboardpop",
  components: {},
  data() {
    return {
      list_version_reverse: [],
      ver_detail: "",
      ver: "",
      sheet_data: [],
      busy: false,
      show_detail: false,
    };
  },

  mounted() {
    this.dataJson();
  },
  methods: {
    dataJson() {
      this.busy = true;
      this.$http
        .get(
          "https://script.google.com/macros/s/AKfycbzmA0jgOyAm_UpaUSLrFItOVlZUDqQ9FiIIZqg6PbYh43iZkXtELSqFQXa5hrjGkH6HEg/exec"
        )
        .then((res) => {
          this.sheet_data = res.data;
          this.dataSheet();
        });
    },
    dataSheet() {
      this.busy = false;
      for (let i = this.sheet_data.length; i >= 0; i--) {
        if (this.sheet_data[i] != undefined) {
          this.list_version_reverse.push(this.sheet_data[i]);
        }
      }
      console.log("Reverse", this.list_version_reverse);
    },
    version_detail(a) {
      this.ver_detail = a;
      this.show_detail = true;
    },
    all_version() {
      this.show_detail = false;
    },
  },
  computed: {},
};
</script>


